class ServiceTimeUpdSessionCollection extends App.Collections.BaseCollection {
    url = 'ServiceTimeUpdSession';
    model = App.Models.ServiceTimeUpdSession;
}

App.Collections.ServiceTimeUpdSessions = ServiceTimeUpdSessionCollection;
